import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/functions'

var firebaseConfig = {
    apiKey: "AIzaSyCRCAN-cwlPAFslSzZa8hkqysmw1uwaqpY",
    authDomain: "itays-restaurant.firebaseapp.com",
    databaseURL: "https://itays-restaurant.firebaseio.com",
    projectId: "itays-restaurant",
    storageBucket: "itays-restaurant.appspot.com",
    messagingSenderId: "312158986905",
    appId: "1:312158986905:web:92196a75455efd6d94ce08",
    measurementId: "G-D00DSBBSDS"
 };
 
 // Initialize Firebase
 firebase.initializeApp(firebaseConfig);
 firebase.analytics();

 export default firebase